export default {
    title: '毛豆随行',
    baseUrl: {
        dev: 'http://192.168.1.105:8089',
        pro: 'https://tesla.touping.vip',
        dev1: 'http://192.168.1.105:8081'
    },
    uploadAction: '/api/admin/upload',
    imgServer: 'https://tesla-1315013704.cos.ap-beijing.myqcloud.com/static'
}
